<template>
  <table>
      <colgroup>
        <col class="col-w-1">
        <col class="col-w-10">
        <col class="col-w-100">
        <col :class="[ edit ? 'col-w-20' : 'col-w-1' ]">
      </colgroup>
      <thead>
        <tr class="item">
          <th></th>
          <th>{{ $t('label.date') }}</th>
          <th class="no-padding">
            <div class="tabs tabs--index-list-header is-small">
              <ul>
                <li
                  v-for="(measurementTypeGroup, key) in measurement.MeasurementTypeGroups"
                  v-if="measurementTypeGroup.code !== MEASUREMENT_TYPE_GROUPS.BODY_MASS_INDEX"
                  :class="{ 'is-active': measurementTypeGroup.code === activeMeasurementTypeGroup }"
                  @click="activeMeasurementTypeGroup = measurementTypeGroup.code">
                  <a>{{ measurementTypeGroup.name }}</a>
                </li>
              </ul>
            </div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="item">
          <td class="cell-w-1">
            <nuttrema-iconica-bmi :measurement="measurement.MeasurementTypeGroups[MEASUREMENT_TYPE_GROUPS.BODY_MASS_INDEX]"></nuttrema-iconica-bmi>
          </td>
          <td class="cell-w-10">
            <h4>{{ measurement.measurement_timestamp | moment('ll') }}</h4>
            <p>{{ measurement.measurement_timestamp | moment('LT') }}</p>
          </td>
          <td class="cell-w-100 is-white-overlay">
            <ul class="tab-measurement-content"
              v-for="measurementTypeGroup in measurement.MeasurementTypeGroups"
              v-if="measurementTypeGroup.code === activeMeasurementTypeGroup">
              <template v-for="trackingGroup in measurementTypeGroup.TrackingGroups">
                <component
                   v-bind:is="componentName(trackingGroup.display)"
                  :trackingGroup="trackingGroup">
                </component>
              </template>
            </ul>
          </td>
          <td :class="[ edit ? 'col-w-20' : 'col-w-1' ]">
            <router-link
               v-if="edit"
               class="el-button el-button--text"
              :to="{ name: _get(meta, 'navigation.edit'), params: { measurementID: measurement.id } }">
              {{ $t('label.view_detail') }} <i class="el-icon-arrow-right" aria-hidden="true"></i>
            </router-link>
          </td>
        </tr>
      </tbody>
  </table>
</template>

<script>
import { findKey } from 'lodash';
import { MEASUREMENT_TYPE_GROUPS } from 'constants/measurement-types';

import NuttremaIconicaBmi from 'components/ui/label/nuttrema-iconica-bmi';

import LabelGroupMultiple from './tracked-measurements-label-groups/label-group-multiple';
import LabelGroupPercentagePrimaryValue from './tracked-measurements-label-groups/label-group-percentage-primary-value';
import LabelGroupPercentageValue from './tracked-measurements-label-groups/label-group-percentage-value';
import LabelGroupSingle from './tracked-measurements-label-groups/label-group-single';
import LabelGroupValueLevel from './tracked-measurements-label-groups/label-group-value-level';

export default {
  name: 'participants-index-list-item',
  props: {
    meta: {
      required: true,
      default: null,
    },
    edit: {
      required: false,
      default: false,
    },
    measurement: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      activeMeasurementTypeGroup: null,
      MEASUREMENT_TYPE_GROUPS,
    };
  },
  computed: {
    picture() {
      return this.item.ProfilePicture ? `${process.env.IMAGES_ROOT}${this.item.ProfilePicture.path}${this.item.ProfilePicture.thumbnails.large.filename}` : null;
    },
  },
  methods: {
    componentName(value) {
      const name = value.replace(/_/g, '-');
      return `label-${name}`;
    },
  },
  components: {
    NuttremaIconicaBmi,
    LabelGroupMultiple,
    LabelGroupPercentagePrimaryValue,
    LabelGroupPercentageValue,
    LabelGroupSingle,
    LabelGroupValueLevel,
  },
  created() {
    const firstKey = findKey(this.measurement.MeasurementTypeGroups, item => item.code !== MEASUREMENT_TYPE_GROUPS.BODY_MASS_INDEX);
    this.activeMeasurementTypeGroup = firstKey;
  },
};
</script>

<style lang="scss">
  @import "~styles/theme/colors";
  @import "~styles/mixins/mixins";
  @import "~styles/component/nuttrema-list-item";

  ul.tab-measurement-content {
    display: block;
    width: 100%;
    height: 100%;
    vertical-align: middle;
    position: absolute;
    left: 0; top: 0;
    overflow: hidden;
    overflow-x: auto;
    padding-right: 50px;
    > li {
      display: inline-block;
      margin: 0.85em 1em 0 0;

      h4 {
        font-weight: 500;
        color: gray;
        font-size: 0.8rem;
        text-transform: uppercase;
      }

      span.measurement-value {
        font-weight: 500;
        margin-right: 0.15em;
      }

      &.split {
        width: 0.5em;
      }
      .values {
        margin-right: 0.5em;
      }
      &:last-child {
        margin-right: 0;
      }
      > ul {
        > li {
          margin-right: 0.5em;
          display: inline-block;
          box-sizing: border-box;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/cmpt-measurements-index-list-item.vue